/* esm.sh - unhead@3.4.1/dist/shared/unhead.CHEy9ana */
function n(e,f){return f&&typeof e=="function"&&(e.key=f),e}export{n as d};
//# sourceMappingURL=unhead.CHEy9ana.mjs.map